/* GOS Player Gear — listing page: sport tabs, brand chips, Men/Women, sort and search.
   No dependencies. Works on every card rendered by snippets/gos-player-card.liquid. */
(function () {
  function norm(text) {
    return String(text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
  }

  function init(root) {
    var grid = root.querySelector('[data-pg-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pg-card]'));
    var search = root.querySelector('[data-pg-search]');
    var sortSel = root.querySelector('[data-pg-sort]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pg-tab]'));
    var genderBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pg-gender]'));
    var brandWrap = root.querySelector('.pg-brands');
    var allBrandBtn = root.querySelector('[data-pg-brand="all"]');
    var shownEl = root.querySelector('[data-pg-shown]');
    var emptyEl = root.querySelector('[data-pg-empty]');
    var emptyQ = root.querySelector('[data-pg-empty-q]');
    var resetBtn = root.querySelector('[data-pg-reset]');

    var state = { q: '', sport: 'all', gender: 'all', brand: 'all', sort: 'featured' };

    // Read state from the URL so filtered views can be shared, e.g. ?sport=tennis&q=sinner
    var params = new URLSearchParams(window.location.search);
    if (params.get('sport')) state.sport = params.get('sport');
    if (params.get('q')) state.q = params.get('q');
    if (search && state.q) search.value = state.q;

    // Totals
    Array.prototype.forEach.call(root.querySelectorAll('[data-pg-total]'), function (el) { el.textContent = cards.length; });

    // Build brand chips from the cards (alphabetical)
    var brands = [];
    cards.forEach(function (c) {
      var b = c.getAttribute('data-brand');
      if (b && brands.indexOf(b) === -1) brands.push(b);
    });
    brands.sort(function (a, b) { return a.localeCompare(b); });
    var brandBtns = allBrandBtn ? [allBrandBtn] : [];
    var countEl = root.querySelector('.pg-count');
    brands.forEach(function (b) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pg-chip';
      btn.setAttribute('data-pg-brand', b);
      btn.setAttribute('aria-pressed', 'false');
      btn.textContent = b;
      brandWrap.insertBefore(btn, countEl);
      brandBtns.push(btn);
    });

    // Keep the original order for "Featured" sorting
    cards.forEach(function (c, i) { c._pgIndex = i; c._pgSearch = norm(c.getAttribute('data-search')); });

    function matches(c, ignoreSport) {
      if (!ignoreSport && state.sport !== 'all' && c.getAttribute('data-sport') !== state.sport) return false;
      if (state.gender !== 'all' && c.getAttribute('data-gender') !== state.gender) return false;
      if (state.brand !== 'all' && c.getAttribute('data-brand') !== state.brand) return false;
      var q = norm(state.q);
      if (q && c._pgSearch.indexOf(q) === -1) return false;
      return true;
    }

    function sortCards(list) {
      var s = state.sort;
      return list.slice().sort(function (a, b) {
        if (s === 'player') return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'));
        if (s === 'gear') return a.getAttribute('data-gear').localeCompare(b.getAttribute('data-gear'));
        var fa = +a.getAttribute('data-featured'), fb = +b.getAttribute('data-featured');
        if (fa !== fb) return fb - fa;
        var oa = +a.getAttribute('data-order'), ob = +b.getAttribute('data-order');
        if (oa !== ob) return oa - ob;
        return a._pgIndex - b._pgIndex;
      });
    }

    function render() {
      // Tab counts reflect search, brand and gender, so shoppers see where results are
      tabs.forEach(function (t) {
        var id = t.getAttribute('data-pg-tab');
        var n = cards.filter(function (c) { return matches(c, true) && (id === 'all' || c.getAttribute('data-sport') === id); }).length;
        var countSpan = t.querySelector('[data-pg-tab-count]');
        if (countSpan) countSpan.textContent = n;
        t.setAttribute('aria-selected', id === state.sport ? 'true' : 'false');
      });
      genderBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pg-gender') === state.gender ? 'true' : 'false'); });
      brandBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pg-brand') === state.brand ? 'true' : 'false'); });

      var visible = 0;
      sortCards(cards).forEach(function (c) {
        grid.appendChild(c);
        var show = matches(c, false);
        c.hidden = !show;
        if (show) visible++;
      });
      if (shownEl) shownEl.textContent = visible;
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (emptyQ) emptyQ.textContent = state.q;
      grid.hidden = visible === 0;
    }

    tabs.forEach(function (t) { t.addEventListener('click', function () { state.sport = t.getAttribute('data-pg-tab'); render(); }); });
    genderBtns.forEach(function (b) { b.addEventListener('click', function () { state.gender = b.getAttribute('data-pg-gender'); render(); }); });
    brandWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pg-brand]');
      if (!b) return;
      state.brand = b.getAttribute('data-pg-brand');
      render();
    });
    if (search) search.addEventListener('input', function () { state.q = search.value; render(); });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; render(); });
    if (resetBtn) resetBtn.addEventListener('click', function () {
      state = { q: '', sport: 'all', gender: 'all', brand: 'all', sort: state.sort };
      if (search) search.value = '';
      render();
    });

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pg-listing]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-run when the section is edited in the theme editor
  document.addEventListener('shopify:section:load', boot);
})();